import React, { useState } from 'react';
import ImageModal from './ImageModal';

function RealisticGallery() {
  const [noOfElements, setNoOfElement] = useState(20);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const galleryImages = {
    Gallery: [
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323252-663dc1740fc87.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323332-663dc1c40d61c.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323342-663dc1ce3de08.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323353-663dc1d935a5e.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323362-663dc1e2e3bbf.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323371-663dc1ebd45f7.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323382-663dc1f60a4fa.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323395-663dc203d192a.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323438-663dc22e8d22c.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323448-663dc238cb8e5.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323462-663dc24653547.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323471-663dc24fa9f45.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323538-663dc2921f7ee.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323548-663dc29c53005.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323576-663dc2b872088.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323587-663dc2c30468d.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323596-663dc2ccab404.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323611-663dc2db4bbc0.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323621-663dc2e5902da.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323630-663dc2ee80a00.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323686-663dc32663a24.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323707-663dc33b87ae2.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323717-663dc34542f51.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323730-663dc35261062.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323785-663dc389af7f8.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323799-663dc3972dc98.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323809-663dc3a190fac.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323820-663dc3ac46b65.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323830-663dc3b6d96e6.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323846-663dc3c678c72.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323857-663dc3d15a58f.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323867-663dc3db7f8f3.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323950-663dc42ea94dc.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323960-663dc4388ec0c.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323969-663dc44148966.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323981-663dc44dd6c23.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323990-663dc456d68b1.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715323999-663dc45f6b512.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324009-663dc46949a70.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324017-663dc4711b458.jpg',
      },
    ],
  };

  const loadMore = () => {
    setNoOfElement(noOfElements + 20);
  };

  const openImageModal = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImageModal = () => {
    setSelectedImageIndex(null);
  };

  return (
    <>
      <div className="tab-content">
        <div className="tabcontent1">
          <div className="tabcontent1GalleryInner clearfix">
            {galleryImages.Gallery.slice(0, noOfElements).map((res, index) => {
              return (
                <div className="tabcontentGallery col-3" key={index}>
                  <div className="tabcontentGalleryInner">
                    <img
                      src={`${res.ImageGallery_MediaUrl}`}
                      alt="realistic-gallery"
                      onClick={() => openImageModal(index)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <button
            style={{
              display:
                noOfElements >= galleryImages.Gallery.length
                  ? 'none'
                  : 'block',
            }}
            className="loadmoreGalleryBtn"
            onClick={() => loadMore()}
          >
            LOAD MORE
          </button>
        </div>
      </div>
      {selectedImageIndex !== null && (
        <ImageModal
          images={galleryImages.Gallery}
          selectedIndex={selectedImageIndex}
          onClose={closeImageModal}
        />
      )}
    </>
  );
}

export default RealisticGallery;